import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startNodeLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-node.start-node-label',
		defaultMessage: "Start - issues transition from here when they're created.",
		description: 'Label for start node',
	},
	statusNodeLabel: {
		id: 'accessible-workflow-diagram.list-navigation.list-node.status-node-label',
		defaultMessage: '{statusName} status.',
		description: 'Label for a status node',
	},
	startNodeLabelIssueTermRefresh: {
		id: 'accessible-workflow-diagram.list-navigation.list-node.start-node-label-issue-term-refresh',
		defaultMessage: 'Start - transition from here once created.',
		description: 'Label for start node',
	},
});
